import { useState } from "react";

const faqs = [
  {
    question: "What industries and clients does Paladin work with?",
    answer:
      "Paladin works with a wide range of clients — licensed professionals (doctors, lawyers, accountants, IT consultants, real estate agents), business owners of all sizes, landlords, contractors, fleet operators, and individual personal insurance clients. If you have something worth protecting, we have a solution built for you.",
  },
  {
    question: "Can Paladin handle coverage needs across multiple insurance types?",
    answer:
      "Absolutely. Paladin specializes in coordinating coverage across multiple lines. For example, a contractor might need General Liability, Workers' Compensation, Commercial Auto, and Umbrella Insurance together. Our agents assess your full risk profile and build a comprehensive, cohesive plan that covers all your bases.",
  },
  {
    question: "Do you provide one-on-one guidance throughout the process?",
    answer:
      "Yes. One-on-one guidance is central to Paladin's promise. From your first consultation to policy finalization, a dedicated licensed agent will walk you through every step — explaining your options, comparing providers, and making sure you fully understand what you're covered for and why.",
  },
  {
    question: "Can I work with Paladin if I'm outside of California?",
    answer:
      "Yes! Paladin is licensed in California (CA), Arizona (AZ), Idaho (ID), Illinois (IL), Indiana (IN), Nevada (NV), North Carolina (NC), Ohio (OH), and Texas (TX). If your business or property is in any of these states, our agents can work with you — in person or remotely.",
  },
  {
    question: "Do you offer ongoing support after I get a policy?",
    answer:
      "Yes. Paladin's commitment doesn't end when you sign your policy. Our agents remain available Monday through Friday, 9:00 AM – 5:00 PM, to assist with questions, policy adjustments, renewals, and claims guidance. You'll always have a trusted advisor in your corner.",
  },
  {
    question: "Is my personal and business information kept confidential?",
    answer:
      "Absolutely. At Paladin, we treat every client's information with the same care and discretion we would apply to our own family. Your data is used solely to find and manage the right coverage for you and is never shared without your explicit consent.",
  },
];

function FaqItem({ question, answer, isOpen, onToggle }) {
  return (
    <div
      className={`border transition-all duration-200 overflow-hidden ${
        isOpen
          ? "border-blue-dark border-opacity-25 bg-white-pure shadow-sm"
          : "border-blue-dark border-opacity-8 bg-white-pure bg-opacity-50 hover:bg-opacity-80 hover:border-opacity-18"
      }`}
      style={{ borderRadius: "16px" }}
    >
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between px-7 py-5 text-left group"
        aria-expanded={isOpen}
      >
        <span
          className={`font-constantia font-bold pr-5 transition-colors duration-150 ${
            isOpen ? "text-blue-dark" : "text-blue-dark opacity-75 group-hover:opacity-100"
          }`}
          style={{ fontSize: "15.5px", lineHeight: "1.45" }}
        >
          {question}
        </span>

        <span
          className={`flex-shrink-0 w-7 h-7 rounded-full border flex items-center justify-center ${
            isOpen
              ? "bg-blue-dark border-blue-dark text-white-pure"
              : "border-blue-dark border-opacity-20 text-blue-dark group-hover:border-opacity-40"
          }`}
          style={{
            fontSize: "17px",
            lineHeight: 1,
            transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
            transition: "transform 0.25s ease, background 0.2s, border-color 0.2s",
          }}
          aria-hidden="true"
        >
          +
        </span>
      </button>

      <div
        style={{
          display: "grid",
          gridTemplateRows: isOpen ? "1fr" : "0fr",
          transition: "grid-template-rows 0.28s ease",
        }}
      >
        <div style={{ overflow: "hidden" }}>
          <div className="px-7 pb-6">
            <div className="h-px bg-blue-dark opacity-8 mb-4" />
            <p
              className="font-constantia text-black-deep opacity-60 leading-relaxed"
              style={{ fontSize: "15px" }}
            >
              {answer}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function WorkingWithUsFaqsSection({ searchQuery = "" }) {
  const [openIndex, setOpenIndex] = useState(null);

  const filtered = faqs.filter(
    (faq) =>
      faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
      faq.answer.toLowerCase().includes(searchQuery.toLowerCase())
  );

  if (filtered.length === 0) return null;

  return (
    <section id="working" className="bg-white-warm w-full py-16 px-6">
      <div className="max-w-3xl mx-auto">

        <div className="flex items-center gap-3 mb-8">
          <div
            className="bg-blue-dark opacity-50 rounded-full"
            style={{ width: "2px", height: "20px" }}
          />
          <span
            className="font-cinzel text-blue-dark uppercase"
            style={{ fontSize: "10px", letterSpacing: "0.22em" }}
          >
            Working With Us
          </span>
          {searchQuery && (
            <span
              className="ml-auto font-constantia text-blue-dark opacity-35"
              style={{ fontSize: "11px" }}
            >
              {filtered.length} result{filtered.length !== 1 ? "s" : ""}
            </span>
          )}
        </div>

        <div className="flex flex-col gap-3">
          {filtered.map((faq, index) => (
            <FaqItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              onToggle={() => setOpenIndex(openIndex === index ? null : index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}